import React from "react";
import { Button } from '@kdcloudjs/kdesign'
import eventBus from '../../../../../../util/eventBus'

const btnStyle = { marginLeft: '10px' }

function Nav(props) {
    console.log("-----btn app-----", props);

    const { model, myInvoke, hasPositionExportPerm = 0, currentNodeIsNull = true, direction = "1", refreshPage } = props

    const { invoke } = model

    function mainClick() {
        myInvoke("positionChartPermQuery", {}, "positionChartPermQuery").then(data => {
            console.log("positionChartPermQuery", data.hasPositionExportPerm, data.hasPositionExportPerm === 1);
            if (data.hasPositionExportPerm === 1) {
                // 导出PNG
                eventBus.pub(model, 'downFile', { type: "0" }, (...args) => { })
            } else {
                // Message.error("无“岗位关系图”的“引出”权限，请联系管理员。")
            }
        })


    }

    function itemClick(args) {
        myInvoke("positionChartPermQuery", {}, "positionChartPermQuery").then(data => {
            console.log("positionChartPermQuery", data.hasPositionExportPerm, data.hasPositionExportPerm === 1);
            if (data.hasPositionExportPerm === 1) {
                // args.value
                eventBus.pub(model, 'downFile', { type: args.value }, args => { })
            } else {
                // Message.error("无“岗位关系图”的“引出”权限，请联系管理员。")
            }
        })


    }

    function handleRefresh() {
        refreshPage()
    }

    function handleExit() {
        invoke("closePositionChart")
    }

    return (
        <div className="btn-bar">
            {!!hasPositionExportPerm && (
                <Button.Dropdown
                    disabled={currentNodeIsNull}
                    style={btnStyle}
                    popperStyle={{ zIndex: 1000 }}
                    overlay={
                        (direction !== "1") ?
                            [
                                { value: '2', label: '导出PDF' },
                            ] :
                            [
                                { value: '1', label: '导出PPT' },
                                { value: '2', label: '导出PDF' },
                            ]
                    }
                    type="similar"
                    onClick={mainClick}
                    onItemClick={itemClick}>
                    导出PNG
                </Button.Dropdown>
            )}
            <Button type="primary" style={btnStyle} onClick={handleRefresh}>刷新</Button>
            <Button type="primary" style={btnStyle} onClick={handleExit}>退出</Button>
        </div>
    )
}

export default Nav